// extracted by mini-css-extract-plugin
module.exports = {"SkeletonLoading":"SkeletonLoading_SkeletonLoading__17HIs","img":"SkeletonLoading_img__PgGIC","shimmer":"SkeletonLoading_shimmer__oGVh1"};